import { ButtonUploadComponentFile, UTCDateString } from 'ats-ui-lib';

export interface ComplementaryForm {
  id: string;
  questions: ComplementaryFormQuestion[];
}

export interface ComplementaryFormQuestion {
  id: string;
  label: string;
  required: boolean;
  type: JobApplicationComplementaryFormQuestionTypeEnum;
  answers: ComplementaryFormAnswer[];
  enableAttachment: boolean;
  requiredAttachment: boolean;
  files: string[];
}

export interface ComplementaryFormAnswer {
  id: string;
  label: string;
  files: Array<string>;
  labelQuestion: string;
  answerDescription: string;
  questionType: JobApplicationComplementaryFormQuestionTypeEnum;
}

export enum JobApplicationComplementaryFormQuestionTypeEnum {
  MultipleChoice = 0,
  OpenQuestion = 1,
}

export interface JobApplicationComplementaryFormTemplate {
  questions: Question[];
  jobApplicationComplementaryFormTemplateId: string;
  jobApplicationComplementaryFormTemplateName: string;
  required: boolean;
  canComplete: boolean;
}

export interface Question {
  questionId: string;
  label: string;
  required: boolean;
  type: JobApplicationComplementaryFormQuestionTypeEnum;
  answers: Answer[] | null;
  enableAttachment: boolean;
  requiredAttachment: boolean;
  answerId: string | null;
  answerDescription: string | null;
  files: ButtonUploadComponentFile[] | null;
}

export interface Answer {
  id: string;
  label: string;
}

export interface JobApplicationComplementaryFormSaveRequest {
  jobApplicationId: string;
  stepId: string;
  jobApplicationComplementaryFormTemplateId: string;
  questions: SavedQuestion[];
}

export interface SavedQuestion {
  questionId: string;
  answerId: string | null;
  answerDescription: string | null;
  files: string[] | null;
}

export interface CanSendAllAnswers {
  canComplete: boolean;
}

export interface IFile {
  name: string;
  createdAt: UTCDateString;
  fileId: string;
  length: number;
}
